import Link from 'next/link';

export interface ICollectionsListProps {
  collections?: { handle: string; title: string }[];
}

export const CollectionsList: React.FC<ICollectionsListProps> = ({
  collections,
}) => {
  if (!collections) {
    return null;
  }

  const sortedCollections = collections.sort(function (
    a: { handle: string; title: string },
    b: { handle: string; title: string },
  ) {
    return a.title.toUpperCase().localeCompare(b.title.toLocaleUpperCase());
  });

  const collectionsByAlpha: {
    [letter: string]: { handle: string; title: string }[];
  } = sortedCollections.reduce(
    (
      acc: {
        [letter: string]: { handle: string; title: string }[];
      },
      collection: { handle: string; title: string },
    ) => {
      if (!(collection.title[0] in acc)) {
        acc[collection.title[0]] = [];
      }

      acc[collection.title[0]].push(collection);

      return acc;
    },
    {},
  );

  return (
    <>
      {Object.keys(collectionsByAlpha).map((letter) => (
        <section key={`letter-${letter}`} className="tw-p-6">
          <h2>{letter.toUpperCase()}</h2>
          <ul className="tw-grid tw-grid-cols-[repeat(auto-fill,minmax(220px,1fr))] tw-gap-3 tw-p-3">
            {collectionsByAlpha[letter].map((collection, key) => (
              <li key={`collection-${letter}-${key}`}>
                <Link href={`/collections/${collection.handle}`} legacyBehavior>
                  <a>{collection.title}</a>
                </Link>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </>
  );
};
